module.exports = __webpack_public_path__ + "static/media/header-sponsors.a7764ec8.png";